import { AuthService } from '../shared/core/auth.service';
import { UsersProject } from './user-management.model';
import { Component, OnInit, ViewEncapsulation, AfterViewInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, FormArray, FormArrayName } from '@angular/forms';
import { AppService } from '../app.service';
import { ProjectItem } from '../project/projectItem';
import { Router } from '@angular/router';
import { IUserInfo, IUserInProject } from '../shared/core/user-info.model';
import { MessageBrokerService } from '../shared/core/message-broker.service';
import { ErrorModel } from '../shared/core/error.model';
import { UserManagementService } from './user-management.service';
import { NotificationsService, Notification } from '../shared/helper-components/index'
import { find } from 'lodash';
import { Location } from '@angular/common';
import { SharedUtils } from '../shared/utils';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { ComponentCanDeactivate } from '../shared/core/index';
import * as $ from 'jquery';
declare var Materialize: any;

@Component(
  {
    selector: 'user-management',
    template: require('./user-management.component.html')
  }
)

export class UserManagementComponent implements OnInit, AfterViewInit, ComponentCanDeactivate{
  @ViewChild('userTerm') userTerm: ElementRef;

  term = new FormControl();
  // userTerm = new FormControl();
  searchResults: Array<ProjectItem>;
  searchUsersResults: Array<IUserInfo>;
  autocompleteInit;
  autocompleteUsersInit;
  appUserInfo: IUserInfo = new IUserInfo();
  isClearanceUser: boolean;
  usersInProject: UsersProject;
  userManagementForm: FormGroup;
  _selectedProject: ProjectItem;
  userSearchRunning: boolean = false;
  openUserMenu: boolean = false;
  selectedUserEmail: string;
  selectedUserStatus: string;
  userMenuClientX;
  userMenuClientY;
  _searchUsersLabel: { [type: string]: string } =
  {
    default: "Name / Email",
    noproject: 'Select a project above first before searching for users'
  };
  options;
  searchObservable: any;
  constructor(
    private _authService: AuthService,
    private _appService: AppService,
    private _router: Router,
    private _messageBrokerService: MessageBrokerService,
    private _userManagementService: UserManagementService,
    private _fb: FormBuilder,
    private _notificationsService: NotificationsService,
    private _location: Location,
    private _errorHandler: GlobalErrorHandler
  ) {
    this.autocompleteInit = {
      data: {
        "__": null,
        "  ": null
      },
      onAutocomplete: (val) => {
        // console.error('onAutocomplete at ' + Date.now() + ':' + val);
        this.selectSearchedProject(val);
      }
    }
    this.autocompleteUsersInit = {
      data: {
        "__": null,
        "  ": null
      },
      onAutocomplete: (val) => {
        // console.error('onAutocomplete at ' + Date.now() + ':' + val);
        this.selectSearchedUsers(val);
      }
    }
  }

  ngOnInit(): void {


    this.userManagementForm = this._fb.group({
      projectId: '',
      selectAll: false,
      // usersProject: this._fb.array([this.initUsersProject()]),
      users: this._fb.array([]),
    });

    this.term.setValue('');

    if (this._authService.userInfo != null && this._authService.userInfo.accessToken) {
      this.appUserInfo = this._authService.userInfo;
      // this.ProcessSearch();
      // this.ProcessUsersSearch();
      this.isClearanceUser = this._authService.isUserInRole(process.env.CLEARANCE_ROLE) || process.env.ENV == 'qa';
    }
    else {
      console.error('UserManagement.ngOnInit()');
      var error = new ErrorModel();
      error.reloadRoute = '/';
      error.shouldRefreshApp = true;
      this._messageBrokerService.showErrorScreen(error);
    }
  }

  ngAfterViewInit(): void {
    $('.tooltipped').tooltip({ delay: 50 });
    SharedUtils.RemoveTooltipIfNeeded();
  }

  initUsersProject(user: IUserInfo = new IUserInfo()): FormGroup {
    return this._fb.group({
      selected: false,
      id: '',
      userId: user.userId,
      userName: user.userName,
      name: user.name,
      lastLoginDate: user.lastLoginDate
    });
  }

  selectAll(e) {
    console.log(e);
    if (e.target.checked) {
      this.usersProject.controls.forEach(element => {
        element.get('selected').setValue(true);
      });
    } else {
      console.log('unchecked');
      this.usersProject.controls.forEach(element => {
        element.get('selected').setValue(false);
      });
    }
    // e.preventDefault();
  }

  removeSelected(e) {
    e.preventDefault();

    var toRemove: FormControl[] = [];
    this.usersProject.controls.forEach(element => {
      if (element.get('selected').value) {
        toRemove.push(element as FormControl);
      }
    });

    toRemove.forEach(element => {
      this.removeItem(element)
    });

    if (this.usersProject.controls.length == 0) {
      this.userManagementForm.get('selectAll').setValue(false);
    }

  }

  removeItem(i: any): void {
    let index = this.findControlIndexBasedOn(i, this.usersProject, 'userName');

    if (index == -1) {
      console.error('ClearanceItemComponent.removeImage() >> control passed in \'' + i + '\' is not of type CIImage');
      return;
    }
    this.usersProject.removeAt(index);
    this.userManagementForm.markAsDirty();
  }

  private findControlIndexBasedOn(i: any, controlsArray: FormArray, property: string): number {

    if (!i) {
      return;
    }

    if (!i.value || !i.value.hasOwnProperty(property) || !i.value[property]) {
      console.error('UserManagementComponent.findControlIndexBasedOn() >> no property \'' + property + '\' exists in formArray');
      return;
    }

    let controlIndex = controlsArray.controls.findIndex(c => c.get(property).value == i.value[property]);

    if (controlIndex == -1) {
      console.error('UserManagementComponent.findControlIndexBasedOn() >> control passed in \'' + i + '\' is not of type formArray');
      return;
    }

    return controlIndex;

  }

  get usersProject(): FormArray {
    return <FormArray>this.userManagementForm.get('users');
  }

  // set usersProject(arr: FormArray)  {
  //   this.userManagementForm.get('users').setValue([]);//.setValue(arr.value);
  // }

  get searchUsersLabel(): string {
    return this._selectedProject ? this._searchUsersLabel['default'] : this._searchUsersLabel['noproject'];
  }

  selectSearchedProject(val: any): void {
    // this.usersProject = this._fb.array([]);
    this.resetForm(true);
    // console.log('selectSearchedProject');
    if (this.searchResults == null || this.searchResults.length == 0 || !val) {
      return;
    }

    var selectedProject = this.searchResults.find(it => it.ProjectName == val);

    // console.log('selectedProject' + selectedProject);

    if (selectedProject != null && selectedProject.ProjectId) {
      this._selectedProject = selectedProject;

      this._userManagementService.getUsersInProject(selectedProject.ProjectId)
        .subscribe(ret => {
          console.log('selectSearchedProject() >> result:' + JSON.stringify(ret));
          ret.forEach(r => {
            const fb = this.initUsersProject();
            fb.patchValue(r);
            this.usersProject.push(fb);
          });
          $('#searchUsers').focus();
        }, err => {
          if (err.status != 404) {
            this._errorHandler.processError(err);
          }
        });
    }
  }

  selectSearchedUsers(val: any): void {
    if (this.openUserMenu){
      this.openUserMenu=false;
      this.userTerm.nativeElement.value = '';
      this.userTerm.nativeElement.focus();
      this.userTerm.nativeElement.select();
      return;
    }
    val = val.replace('more_vert','').replace('\n','').trim();
    console.log('selectSearchedUsers(val:' + val + ')');
    if (!this._selectedProject){
      this.userTerm.nativeElement.value = '';
      this.userTerm.nativeElement.focus();
      this.userTerm.nativeElement.select();
      this._notificationsService.add(new Notification('error', 'Please select a project first.'));
      return;
    }
    if (this.searchUsersResults == null || this.searchUsersResults.length == 0 || !val) {
      console.log('selectSearchedUsers:' + this.searchUsersResults + ', val:' + val + '; nothing to do...');
      return;
    }

    var status;
    if (val.endsWith('Registered')){
      status = 'Registered';
    }

    if (val.endsWith('Pending')){
      status = 'Pending';
      this._notificationsService.add(new Notification('error', 'The selected user has pending his MyID registration'));
      this.userTerm.nativeElement.value = '';
      this.userTerm.nativeElement.focus();
      this.userTerm.nativeElement.select();
      return;
    }

    if (val.endsWith('Inactive')){
      status = 'Inactive';
      this._notificationsService.add(new Notification('error', 'The selected user does not have a valid MyID registration'));
      this.userTerm.nativeElement.value = '';
      this.userTerm.nativeElement.focus();
      this.userTerm.nativeElement.select();
      return;
    }

    val = val.substring(0, val.indexOf(status));

    var selectedUser = this.searchUsersResults.find(it => it.name+it.email+it.name+it.email == val);
    if (!selectedUser || (selectedUser != null && selectedUser.userId)) {
      console.log('selectSearchedUsers(val: any)' + val);
      let user = this.initUsersProject(selectedUser);

      if (!this.usersProject.value.find(o => o.userName == selectedUser.userName)) {
        this.usersProject.push(user);
        this.usersProject.markAsDirty();
      }
      // $('#searchUsers').val('');
      this.userTerm.nativeElement.value = '';
      this.userTerm.nativeElement.focus();
      this.userTerm.nativeElement.select();
      // $('#searchUsers').focus();
      // $('#searchUsers').select();

    } else {
      console.log('selectedUser:' + selectedUser + '; nothing to do...');
    }

  }

  get NewUsersOnList(): boolean {
    if (this.usersProject && this.usersProject.value.find(o => o.id === ''))
      return true;
    else
      return false;
  }

  get IsProjectSelected(): boolean {
    return this._selectedProject ? true : false;
  }

  public search(input) {
    console.log('search(input):' + input);
    if (input.length >= 3) {
      this._appService.rawSearch(false, input)
        .subscribe(s => {
          this.searchResults = s;

          s.forEach((item, index) => {
            this.autocompleteInit.data[item.ProjectName] = null;
          })
        }, err => {
          console.error('err: ' + JSON.stringify(err));
          if (err.status != 404) {
            this._errorHandler.processError(err);
          }
        }
        )
    }
    if (input.length == 0) {
      this._selectedProject = null;
      this.userManagementForm.markAsPristine();
    }
  }

  public searchUser(input) {
    this.openUserMenu = false;
    if (this.userTerm.nativeElement.nextElementSibling.nextElementSibling.nodeName == 'UL')
      this.userTerm.nativeElement.nextElementSibling.nextElementSibling.style.display = 'none';
    console.log('search(input):' + input);
    if (input.length >= 3) {
      this.userSearchRunning=true;
      var parent = this;
      if (this.searchObservable){
        this.searchObservable.unsubscribe();
      }
      this.searchObservable = this._userManagementService.rawSearchByNameEmail(input).subscribe(s => {
          this.searchUsersResults = s;
          s.forEach((item, index) => {
            parent.autocompleteUsersInit.data[item.name+item.email] = null;
          });
          if (this.userTerm.nativeElement.nextElementSibling.nextElementSibling.nodeName == 'UL')
          {
            this.userTerm.nativeElement.nextElementSibling.nextElementSibling.style.display = '';
          }
          
          
        }, err => {
          if (err.status != 404) {
            this.userSearchRunning=false;
            this._errorHandler.processError(err);
          }
        }, () => {
            this.searchUsersResults.forEach((item, index) => {
            this.addColumnsToUserAutocompleteListItem(item);
            
          });
          this.userSearchRunning=false;
        }
        );
    }
  }


  projectHasChanged(e) {
    console.log('project has changed...');
  }

  saveUsersProject(): void {

    console.log('saveUsersProject()');

    if (this.userManagementForm.dirty && this.userManagementForm.valid) {
      // Copy the form values over the product object values
      var up: UsersProject = Object.assign({}, this.usersInProject, this.userManagementForm.value);

      console.warn('up:' + JSON.stringify(up));
      up.projectId = this._selectedProject.ProjectId;

      this._userManagementService.updateUsersProject(up)
        .subscribe(
        (p) => this.onSaveComplete(false, up.users),
        (error: any) => {
          this._errorHandler.processError(error);
        }
        );
    } else if (!this.userManagementForm.dirty) {
      //this should not be
      this.onSaveComplete(true, []);
    }
  }

  onSaveComplete(resetProjects: boolean, users:IUserInProject[]): void {

    console.log('ProjectDetailComponent.OnSaveComplete >> success...');
    this.resetForm(resetProjects);
    this._notificationsService.add(new Notification('success', 'User has been successfully ' + (users && users.length > 0 ? 'assigned to' : 'removed from') + ' project \'' + this._selectedProject.ProjectName + '\''));
  }

  resetForm(resetArray: boolean=false){
    if (this.userTerm){
      this.userTerm.nativeElement.value = '';
      while (resetArray && this.usersProject.length) {
        this.usersProject.removeAt(0);
        }
    }
    this.userManagementForm.markAsPristine();
  }

  cancelClicked() {
    if (this.userManagementForm.dirty){
      this.userManagementForm.reset();
      this.userManagementForm.markAsPristine();
    }
    if (this._selectedProject){
      $('#searchProject').val(this._selectedProject.ProjectName);
      this.selectSearchedProject(this._selectedProject.ProjectName);
    }
  }

  addColumnsToUserAutocompleteListItem(userItem){
    var $searchInput = $("#searchUsers");
    var $ul;
    var columnWidth = Math.trunc(this.userTerm.nativeElement.clientWidth/12);
    $ul = $searchInput.parent().children('.autocomplete-content.dropdown-content').first();
    $ul.children().each((index,elem)=>{
      if (elem.innerText.replace(/[\n\r]+/g, '') == userItem.name+userItem.email){
        elem.style.gridTemplateColumns = `${columnWidth*4}px ${columnWidth*5}px ${columnWidth*2}px ${columnWidth*1}px 0px`;
        elem.style.cursor = 'default';
        elem.childNodes[0].style="grid-column:4; display:none;"
        elem.style.display = "grid";
        elem.style.position = "relative";
        elem.innerHTML = elem.innerHTML + `<div style='grid-column:1; padding: 14px 16px;margin: 10px; cursor: pointer'>${userItem.name}</div>`
        elem.innerHTML = elem.innerHTML + `<div style='grid-column:2; padding: 14px 16px;margin: 10px; cursor: pointer'>${userItem.email}</div>`
        elem.innerHTML = elem.innerHTML + `<div style='grid-column:3; padding: 14px 16px;margin: 10px; border-radius:30px;text-align:center;${userItem.status=='Registered'?'background-color:#9ded89;color:#2f7f1b':'background-color:#ffe597;color:#9c7500'} '>${userItem.status}</div>`
        elem.innerHTML = elem.innerHTML + `<div style='grid-column:4; padding: 14px 16px;margin: 10px; position: absolute'>
        <a onmouseenter="this.style.cursor='pointer';"onmouseleave="this.style.cursor='default';"><i class="material-icons">more_vert</i></a></div>`
        elem.children[4].children[0].addEventListener("mousedown",(event: Event) => {
          this.openUserOptions(event);
        });
        elem.children[4].children[0].addEventListener("touchstart",(event: Event) => {
          this.openUserOptions(event);
        });
      }
    });
  }

  @HostListener('window:beforeunload')
    canDeactivate(): boolean {
        let isFormClean = !this.userManagementForm.dirty;
        return isFormClean;
    }

  openUserHelpModal(){
    $('#modal-user-help').modal('open');
  }

  openUserOptions(event){
    event.preventDefault();
    event.stopPropagation();
    this.selectedUserEmail = event.currentTarget.parentElement.parentElement.children[2].innerText;
    this.selectedUserStatus = event.currentTarget.parentElement.parentElement.children[3].innerText;
    if (event.type=='mousedown'){
      this.userMenuClientX = `${event.clientX-370}px !Important`;
      this.userMenuClientY = `${event.clientY-80}px !Important`;
    }
    if (event.type=='touchstart'){
      this.userMenuClientX = `${event.touches[0].clientX-370}px !Important`;
      this.userMenuClientY = `${event.touches[0].clientY-80}px !Important`;
    }
    this.openUserMenu = true;
    $('#modal-user-menu').modal('open');
  }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/users/user-management.component.ts